import { OpenInNew, Edit, Visibility, Comment } from "@material-ui/icons";
import React from "react";
import "./Stories.scss";
import moment from "moment/moment";
import { RouteComponentProps, withRouter } from "react-router";
import black from "../../icons/default2.png";
import ReactGA from "react-ga";

export type Publish = {
    id: string;
    avatar: string;
    title: string;
    updatedAt: Date;
    comments: number;
    views: number;
};

export function mapToPublish(data: { [key: string]: any }): Publish {
    return {
        id: data.id,
        avatar: data.cover_image,
        title: data.title,
        updatedAt: new Date(data.updated_at * 1000),
        comments: data.number_of_comments,
        views: 0,
    };
}

const Published: React.FC<{ published: Publish[] } & RouteComponentProps> = ({
    published,
    history,
}) => {
    return (
        <React.Fragment>
            {published.map((draft, index) => (
                <div className="draft">
                    <div className="image">
                        <img
                            src={
                                draft.avatar.trim() !== ""
                                    ? draft.avatar
                                    : black
                            }
                        />
                    </div>
                    <div className="content">
                        <h5>
                            {draft.title.length > 80
                                ? draft.title.substr(0, 80) + "..."
                                : draft.title}
                        </h5>
                        <p>
                            Published on{" "}
                            {moment(draft.updatedAt).format(
                                "Do MMMM YYYY [at] h:mm a"
                            )}
                        </p>
                        <div className="flex space-between">
                            <div className="concat-buttons">
                                <button
                                    onClick={() => {
                                        ReactGA.event({
                                            category: "My Stories",
                                            action: "Edit published",
                                            label: draft.id,
                                        });
                                        history.push(
                                            "/writer/write?story_id=" + draft.id
                                        );
                                    }}
                                >
                                    <Edit />
                                    Edit
                                </button>
                                <button
                                    onClick={() => {
                                        ReactGA.event({
                                            category: "My Stories",
                                            action: "View published",
                                            label: draft.id,
                                        });
                                        history.push(
                                            "/writer/read/" + draft.id
                                        );
                                    }}
                                >
                                    <OpenInNew />
                                    View
                                </button>
                            </div>

                            <div>
                                {/* <Visibility />
                                {draft.views} */}
                                <Comment />
                                {draft.comments}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default withRouter(Published);
